  // #登录路由加参数
  // 1. 正确获取登录按钮元素（使用 querySelector）
  let loginIn = document.querySelector('.account-actions__link .button');

  function setLoginHref() {
    // 2. 获取当前路由（当前页面的URL路径）
    const currentPath = window.location.pathname; // 例如：/pages/home 或 /about
    const targetUrl = currentPath || '/'; // 默认跳转首页
    // 3. 给登录按钮设置 href，携带当前路由作为 redirect 参数
    if (loginIn && loginIn.href !== undefined) {
      // 对路径进行编码，避免特殊字符导致URL错误
      loginIn.href = `/pages/login?redirect_url=${encodeURIComponent(targetUrl)}`;
    }
  }
  // 执行函数设置登录链接
  setLoginHref();


  //#登录用户重定向到用户信息
  if(window.CustomerID){
    const userRouterList = [
      '/pages/login',
      '/pages/register',
      '/pages/forgot-password',
    ];
    const currentPath = window.location.pathname;
    if (userRouterList.includes(currentPath)) {
      window.location.href = '/pages/user-information';
    }
  }


  // 获取用户信息
  // 从localStorage中获取
  const storedUserInfo = localStorage.getItem('userinfo');

  // 转为对象（如果存储的不是空字符串）
  let userData = storedUserInfo ? JSON.parse(storedUserInfo) : null;
  
  console.log(window.CustomerID)
  if(userData && userData.user_id && window.CustomerID){
    userData.CustomerID = window.CustomerID
  }
  console.log(userData)

  // 需要控制的元素ID数组
  const restrictedElements = [
    'support_item_manuals', // support中心入口
    'support_item_videotutorial',// support中心入口
    'support_item_photos',// support中心入口
    'support_navigation_manuals', // support中心热门说明书tag
    'support_navigation_video', // support中心热门视频tag
    'collectiveness_item3', // support中心热门说明书内容
    'collectiveness_item4', // support中心热门视频内容
    'nav_support_videotutorial',// 顶部
    'nav_support_photos',// 顶部
    'nav_support_manuals',// 顶部
    'nav_support_warrantyPolicy'// 顶部
  ];

  // 检查用户是否有权限
  // 从localStorage中获取用户信息
  const UserInfo = localStorage.getItem('userinfo');
  // 转为对象（如果存储的不是空字符串）
  let userDataObj = UserInfo ? JSON.parse(UserInfo) : null;

  // 安全检查用户是否有 Agents 权限
  const hasAgentsPermission = () => {
    // 先判断 userDataObj 是否存在，不存在直接返回 false
    if (!userDataObj) return false;
    
    // 检查必要条件：user_id 存在且 permissions 是数组
    if (
      userDataObj.user_id && 
      Array.isArray(userDataObj.permissions)
    ) {
      // 定义需要检查的权限列表
      const requiredPermissions = [
        "video_course.check",
        "user_manual.check",
        "faq.check",
        "rma.check"
      ];
      
      // 检查是否包含任一权限
      return requiredPermissions.some(permission => 
        userDataObj.permissions.includes(permission)
      );
    }
    
    // 不满足条件时返回 false
    return false;
  };

  // 处理元素显示/隐藏
  function hidden_element(){
    if (!hasAgentsPermission()) {
      restrictedElements.forEach(elementId => {
        const element = document.getElementById(elementId);
        if (element) {
          element.remove(); // 或者使用 element.style.display = 'none';
        }
      });
    }
  }

  hidden_element()

  // 需要限制的路径数组
  const restrictedPaths = [
    '/pages/videotutorial',
    '/pages/photos',
    '/pages/manuals',
    '/pages/warranty-policy'
  ];
  // 检查当前路径是否需要权限
  const currentPath = window.location.pathname;
  if (restrictedPaths.includes(currentPath)) {
    // 如果没有权限，重定向
    if (!hasAgentsPermission()) {
      window.location.href = '/pages/support';
    }
  }

